import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/view/home'
import welfare from '@/view/welfare/index'
Vue.use(Router)

export default new Router({
  linkActiveClass: 'active',
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld,
    },
    {
      path: '/welfare',
      name: 'welfare',
      component: () => import('@/view/welfare/index')
    },
    {
      path: '/publicwelfare',
      name: 'publicwelfare',
      props: true,
      component: () => import('@/view/welfare/publicwelfare')

    },

    {
      path: '/education',
      name: 'Education',
      component: () => import('@/view/education/index')
    },
    {
      path: '/educationContent',
      name: 'EducationContent',
      component: () => import('@/view/education/educationContent')
    },
    {
      path: '/certificate/result',
      name: 'Certificate',
      component: () => import('@/view/education/certificateResult')
    },
    {
      path: '/education/msg',
      name: 'EducationMsg',
      component: () => import('@/view/education/educationMsg')
    },
    {
      path: '/party',
      name: ' Party',
      component: () => import('@/view/party/party')
    },
    {
      path: '/party/partyContent',
      name: ' PartyContent',
      component: () => import('@/view/party/partyContent')
    },
    {
      path: '/handleguide',
      name: ' handleguide',
      component: () => import('@/view/handleguide/handleguide')
    },
    {
      path: '/party/content',
      name: ' PartyContent',
      component: () => import('@/view/party/partyContent')
    },
    {
      path: '/checkMsg',
      name: 'checkMsg',
      component: () => import('@/view/checkMsg')
    }, {
      path: '/learn',
      name: 'learn',
      component: () => import('@/view/learn')
    },
    {
      path: '/recruit',
      name: 'recruit',
      component: () => import('@/view/recruit/list')
    },
    {
      path: '/recruit/details',
      name: 'details',
      component: () => import('@/view/recruit/details')
    },
    {
      path: '/center',
      name: 'Center',
      component: () => import('@/view/center/center')
    }, {
      path: '/enchiridion',
      name: 'enchiridion',
      component: () => import('@/view/enchiridion/enchiridion')
    }, {
      path: '/meeting',
      name: 'meeting',
      component: () => import('@/view/meeting')
    }, {
      path: '/propose',
      name: 'propose',
      component: () => import('@/view/propose')
    }, {
      path: '/contactUs',
      name: 'contactUs',
      component: () => import('@/view/contactUs')
    }, {
      path: '/specialColumn',
      name: 'specialColumn',
      component: () => import('@/view/specialColumn')
    },
    {
      path: '/trainsession',
      name: 'trainsession',
      component: () => import('@/view/trainsession')
    },
    {
      path: '/patentRecommendation',
      name: 'patentRecommendation',
      component: () => import('@/view/patentRecommendation')
    },


  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js